// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__YU8yL","inner":"Footer_inner__XwWoP","light":"Footer_light__IFXjz","left":"Footer_left__PFVIU"};